export const TicketSoldIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.3249 4.13341C14.3249 4.14175 14.3249 4.14175 14.3249 4.15008C14.1166 4.14175 13.9083 4.13341 13.6833 4.13341H7.2666L8.15827 3.25008C8.97493 2.42508 9.87494 1.66675 10.9166 1.66675C11.9666 1.66675 12.8666 2.42508 13.6833 3.25008L14.1499 3.71675C14.2666 3.82508 14.3249 3.97508 14.3249 4.13341Z"
        fill="white"
      />
      <path
        d="M17.3667 10.975C17.6917 10.975 17.95 10.7083 17.95 10.375V9.64167C17.95 6.36667 16.95 5.375 13.6834 5.375H8.43338H6.31671C3.05005 5.375 2.05005 6.375 2.05005 9.64167V10C2.05005 10.3333 2.30838 10.5917 2.63338 10.5917C3.33338 10.5917 3.89172 11.1583 3.89172 11.85C3.89172 12.5417 3.33338 13.1167 2.63338 13.1167C2.30838 13.1167 2.05005 13.375 2.05005 13.7083V14.0667C2.05005 17.3417 3.05005 18.3333 6.31671 18.3333H8.42505H13.675C16.9417 18.3333 17.9417 17.3333 17.9417 14.0667C17.9417 13.7417 17.6834 13.475 17.3584 13.475C16.6584 13.475 16.1 12.9167 16.1 12.225C16.1084 11.5333 16.6667 10.975 17.3667 10.975ZM9.01671 15.7167C9.01671 16.0417 8.75005 16.3083 8.42505 16.3083C8.10005 16.3083 7.83338 16.0417 7.83338 15.7167V13.4833C7.83338 13.1583 8.10005 12.8917 8.42505 12.8917C8.75005 12.8917 9.01671 13.1583 9.01671 13.4833V15.7167ZM9.01671 10.225C9.01671 10.55 8.75005 10.8167 8.42505 10.8167C8.10005 10.8167 7.83338 10.55 7.83338 10.225V7.99167C7.83338 7.66667 8.10005 7.4 8.42505 7.4C8.75005 7.4 9.01671 7.66667 9.01671 7.99167V10.225Z"
        fill="white"
      />
    </svg>
  )
}
